import { ProjectConfig } from "./models/ProjectConfig";
import mockProjectOptions from "src/shared/util/mock-project-options";
import isDevOrTest from "src/shared/util/is-dev-or-test";
import merge from "lodash/merge";

const initialOptions = {
  network: {
    baseUrl: "",
    basketUrl: "",
    crsfToken: "",
    eventId: 0,
    widgetUrl: "",
    monitoringEnvKey: "",
    pathname: "",
  },
  options: {
    videoType: "",
    brand: "",
    isTestStream: "0",
    streamTitle: "",
    productListTitle: "",
    thumbnailOptions: {
      active: false,
      "product-live-comm": { height: 450, width: 450 },
      "product-live-comm-highlight": { height: 450, width: 450 },
    },
    variantKeys: {
      size: "beden",
      color: "renk",
    },
    showVideo: false,
    showVideoUntil: "",
    showProductsBeforeOnAir: {
      isEnabled: false,
      buyDisabled: false,
      date: "",
    },
  },
  style: {
    isCenter: false,
    posterPc: "",
    posterMobile: "",
    videoBackground: "",
    highlightProductBorder: "",
    hideProductList: false,
    product: {
      currency: "",
      showDiscount: false,
      showCouponCode: false,
      couponText: "",
      productImage: 0,
      buttonColor: "",
    },
    modal: {
      afterModal: false,
    },
  },
};

let projectOptions = {
  default: isDevOrTest()
    ? merge(initialOptions, mockProjectOptions())
    : initialOptions,
};

export default projectOptions;

export const setProjectOptions = (newProjectOptions: ProjectConfig) => {
  if (
    !newProjectOptions?.style ||
    !newProjectOptions?.network ||
    !newProjectOptions?.options
  ) {
    return;
  }
  projectOptions.default = merge(projectOptions.default, newProjectOptions);
};
